export default __webpack_public_path__ + "static/media/st.thomas-landscape.9e44f2ff.jpeg";